import Extend from 'flarum/common/extenders';
import ArenaCard from '../common/models/ArenaCard';
import ArenaBattle from '../common/models/ArenaBattle';
import ArenaProfilePage from './components/ArenaProfilePage';
export default [new Extend.Store().add('arena-cards', ArenaCard).add('arena-battles', ArenaBattle), new Extend.Routes().add('user.arena', '/u/:username/arena', ArenaProfilePage)];